/*
 *             Copyright (c) 2016 - 2020, CKSource - Frederico Knabben. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x3297=['plugins','requires','init','enableCommand','get','editor'];(function(_0x14bf36,_0x1eb829){var _0x386ec7=function(_0x1ad9e9){while(--_0x1ad9e9){_0x14bf36['push'](_0x14bf36['shift']());}};_0x386ec7(++_0x1eb829);}(_0x3297,0x1c0));var _0x4367=function(_0x14bf36,_0x1eb829){_0x14bf36=_0x14bf36-0x0;var _0x386ec7=_0x3297[_0x14bf36];return _0x386ec7;};import _0x520858 from'@ckeditor/ckeditor5-core/src/plugin';import _0x69b306 from'@ckeditor/ckeditor5-comments/src/comments/commentsediting';export default class T extends _0x520858{static get[_0x4367('0x3')](){return[_0x69b306];}[_0x4367('0x4')](){this[_0x4367('0x1')][_0x4367('0x2')][_0x4367('0x0')]('TrackChangesEditing')[_0x4367('0x5')]('addCommentThread');}}